import { type WebPageBlockDataFragment } from '../../../../../api/fragments/WebPageBlockData';
import ColumnBlock from './ColumnBlock';
import CustomBlock from './CustomBlock';
import ImageBlock from './ImageBlock';
import TextCarouseBlock from './TextCarouseBlock';
import TextImageBlock from './TextImageBlock';

type WebPageBlockProps = {
    webpageBlock: WebPageBlockDataFragment[];
};

const WebPageBlock = ({ webpageBlock }: WebPageBlockProps) => (
    <>
        {webpageBlock.map(block => {
            switch (block.__typename) {
                case 'ColumnWebPageBlock':
                    return <ColumnBlock columnBlock={block} />;

                case 'CustomWebPageBlock':
                    return <CustomBlock customBlock={block} />;

                case 'ImageWebPageBlock':
                    return <ImageBlock imageBlock={block} />;

                case 'TextImageWebPageBlock':
                    return <TextImageBlock textImageBlock={block} />;

                case 'TextCarouselWebPageBlock':
                    return <TextCarouseBlock textCarouseBlock={block} />;

                default:
                    throw new Error('WebPageBlockType not support');
            }
        })}
    </>
);
export default WebPageBlock;
